import * as DAOUtils from "../utils/DAOUtils";

export function getUser() {
  return DAOUtils.get("/user");
}

export function getUserCustomers() {
  return DAOUtils.get("/customer/crmClients");
}

export function setCustomer(customerId) {
  return DAOUtils.post(`/user/setCustomer`, {
    CustomerId: customerId,
  });
}
